import core from './core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  getTestApi(parameters={}) {
    return core.call({
      url: '/api/v1/eduApi/getTestApi',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  //내고객보기 > 고객상세 > 진단서비스 KED쿠폰 조회
  getMyCstmrCpon(parameters={}) {
    return core.call({
      url: '/api/v1/eduApi/getMyCstmrCpon',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  }
}
